export default "__VITE_ASSET__DL3vw5IZ__"